"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleTranslationError = exports.IntlErrorCodes = void 0;
const IntlErrorCodes = exports.IntlErrorCodes = {
  MISSING_TRANSLATION: 'MISSING_TRANSLATION'
};
const handleTranslationError = error => {
  if (error.code === IntlErrorCodes.MISSING_TRANSLATION) {
    // Silence errors, caused by replacing messages with fetched values
    return;
  }
  console.error(error);
};
exports.handleTranslationError = handleTranslationError;